<template>
  <div class="APP-BOX clearfix">
    <div v-if="emptyItem == false">
      <div class="block_03 clearfix" id="block_03" :style="backImg">
        <div class="block-n_04 clearfix">
          <h2 class="clearfix">
            <span>您可预约的项目</span>
            <div class="clearfix">
              <!--              <input name="" type="checkbox" value="" v-model="checkAllItem" @change="checkAllItemChange">-->
              <select class="select01" v-model="deptSelected" @change="deptChange">
                <option v-for="dept in deptInfo" :value="dept.deptId" >{{dept.deptName}}</option>
              </select>
            </div>
          </h2>
          <div class="clear"></div>
          <hr/>
          <div class="block_03 clearfix" :style="backImg" v-if="items.length==0">
            <div class="block-n_04 clearfix" id="block-n_04">
              <img class="img001" src="../../../static/img/kk.png"/>
              <div class="k-g">您还没有可预约的项目哦！</div>
            </div>
          </div>
          <div class="div04 clearfix"  v-else v-for="(item,index) in items" :key="index">
            <div class="div04-L clearfix">
              <a href="">
                <img src="../../../static/img/bb_01.png"/><!--<span>1次</span></a>-->
              </a>
            </div>
            <div class="div04-Z clearfix">
              <h3>{{item.treatmentName}}</h3>
              <div v-if="item.singlePoints>0"><span>{{itemsFinalData[index].finalPoints}}</span>积分, 抵扣 <span>{{itemsFinalData[index].finalPoints/100}}</span>元<br/>
              </div>
              <div v-if="item.singleCoupon>0"><span>{{itemsFinalData[index].finalCoupon}}</span>券, 抵扣 <span>{{itemsFinalData[index].finalCoupon}}</span>元
                <br/></div>
              <div v-if="item.singleGold>0"><span>{{itemsFinalData[index].finalGold}}</span>华韩金, 抵扣 <span>{{itemsFinalData[index].finalGold}}</span>元<br/>
              </div>
              <div>预计消费：<span>{{itemsFinalData[index].finalPrice}}元</span></div>

              <p>剩余预约次数：<b>{{item.remainTimes>0?item.remainTimes:'不限'}}</b></p>
              <p>
                <a @click="decreaseTimes(index)">-</a>
                <span>{{item.appointmentTimes}}</span>
                <a @click="increaseTimes(index,item.remainTimes)">+</a>
              </p>
            </div>
            <div class="div04-R clearfix">
              <!-- :value="{'consultRecordId': item.consultRecordId, 'treatmentId': item.treatmentId}" -->
              <input :id="item.treatmentId" name="" type="checkbox" v-model="selectedItems"
                     :value="{'consultRecordId': item.consultRecordId, 'treatmentId': item.treatmentId, 'timeInterval': item.timeInterval, 'itemIndex': index}"
                     :disabled="selectedRecordId!='' && selectedRecordId!=item.consultRecordId"
                     @click="checkAnyItemChange(index, $event)">
            </div>
          </div>
          <!--        <div class="clear"></div>-->
        </div>
        <div class="clear"></div>
        <!--        选择的值为:{{selectedItems}}-->
        <div class="div07 clearfix">
          <section id="form1">
            <label class="label1">专家：</label>
            <select class="select01" v-model="expertSelected">
              <option disabled value="">请选择专家</option>
              <option v-for="et in experts" :value="et.id">{{et.userName}}</option>
            </select>
          </section>
        </div>
        <div class="div07 clearfix">
          <section id="form0">
            <label class="label2">日期：</label>
            <input type="text" readonly class="date" placeholder="请选择手术日期" v-model="appointmentDate"
                   @click="selectDate"/>
            <mt-datetime-picker
              v-model="dateVal"
              ref="picker1"
              type="date"
              :startDate="startDate"
              @confirm="handleDateConfirm">
            </mt-datetime-picker>
          </section>
        </div>
        <div class="div07 clearfix">
          <section id="form2">
            <label class="label2">时间：</label>
            <input type="text" readonly class="time" placeholder="开始时间" v-model="appointmentTime"
                   @click="selectTime"/>
            <mt-datetime-picker
              v-model="timeVal"
              ref="picker2"
              type="time"
              :startHour="7"
              @confirm="handleTimeConfirm">
            </mt-datetime-picker>
            <span class="span01">预计:{{operationTime}}分钟</span>
          </section>
        </div>
        <div class="div07 clearfix" v-if="expertFreeTimes.length>0">
          <span class="zt">{{appointmentDate}} 可约时间</span>
          <ul class="zul">
            <li v-for="(time,index) in expertFreeTimes">{{'- ' + moment(time.beginTime).format('HH:mm') + ' - ' + moment(time.endTime).format('HH:mm')}}</li>
          </ul>
        </div>
        <div class="div07 clearfix">
          <section id="form3">
            <label class="label3">备注：</label>
            <input type="text" class="input3" v-model="schedulerMemo"/>
          </section>
        </div>
      </div>
      <div class="clear"></div>
      <!--<div class="tishi-b clearfix">
        <p>申请后您所属的客管专员会帮助您安排医生的时间&lt;!&ndash;，如帮您预约上后，可以在<a href="">【我的预约】</a>中查看！&ndash;&gt;</p>
      </div>-->
      <div class="div03 clearfix">
        <a class="a03" @click="applyAppointment">确定申请</a>
      </div>
    </div>
    <div class="block_03 clearfix"  :style="backImg" v-else>
      <div class="block-n_04 clearfix" id="block-n_04">
        <img class="img001" src="../../../static/img/kk.png"/>
        <div class="k-g">您还没有可预约的项目哦！</div>
      </div>
    </div>
    <div class="clear"></div>

    <!--<div class="s5">
      <h3><span>你可能还喜欢</span></h3>
      <div class="tuiji">
        <a href="#">
          <img src="images/bb_01.png">
          <div class="tuij_r">
            <h2>[眼部]Magic-eye动态无痕经典系列-去眼袋(内切)</h2>
            <span>预约数：2496<em>浏览：2600</em></span>
            <p>￥9800<em>￥16500</em></p>
          </div>
          <div class="clear"></div>
        </a>
        <div class="clear"></div>
        <p class="p01">限时抢购|活动结束后恢复￥9800，仅剩3个</p>
        <p class="p02">尾款红包|付尾款，最高立减￥800</p>
      </div>
      <div class="clear"></div>
      <div class="htiao"></div>
    </div>-->
  </div>
</template>

<script>
    import schedulerService from '../../services/scheduler-service'
    import commonUtil from '@/utils/commonUtil'
    import userService from '../../services/user-service'
    import {Toast} from 'mint-ui'
    //import Vue from 'vue'
    import moment from 'moment'

    /*Vue.use(moment);
    Vue.prototype.$moment = moment;*/

    export default {
        data() {
            return {
                backImg: commonUtil.setBackImg('top-0'),
                moment: moment,
                deptSelected: -1,
                deptInfo:[{deptId:-1, deptName: '全部项目'},{deptId:10, deptName: '整形科'},{deptId:11, deptName: '皮肤科'},{deptId:12, deptName: '口腔科'},{deptId:24, deptName: '无创中心'}],
                appointmentDate: moment().add(7, 'd').format('YYYY-MM-DD'),
                appointmentTime: '',
                experts: [],
                expertSelected: '',
                schedulerMemo: '',
                dateVal: '',
                timeVal: '',
                items: [],
                itemsTemp:[],
                itemsFinalData: [],
                startDate: moment().add(7, 'd').toDate(), // 默认提前一周开始预约
                checkAllItem: false,
                selectedItems: [],
                selectedRecordId: '',
                itemIsIndeterminate: false,
                emptyItem: false,
                expertFreeTimes: [],
            }
        },
        computed: {
            operationTime() {
                if (this.selectedItems.length > 0) {
                    this.selectedItems.sort((a, b) => {
                        return b.timeInterval - a.timeInterval;
                    });
                    return this.selectedItems[0].timeInterval;
                } else {
                    return 0;
                }
            }
        },
        methods: {
            selectDate() {
                this.$refs.picker1.open();
            },
            selectTime() {
                //this.timeVal = new Date();
                this.$refs.picker2.open();
            },
            handleDateConfirm(data) {
                this.appointmentDate = this.getDate(data);
                this.getExpertFreeTime();
            },
            handleTimeConfirm(data) {
                this.appointmentTime = data;
            },
            getDate(data) {
                return this.moment(data).format('YYYY-MM-DD');
            },
            getTime(data) {
                const time = new Date(data);
                return this.moment(time).format('HH:mm');
            },
            increaseTimes(index, times) {
                if (this.items[index].appointmentTimes == times) {
                    Toast('不能大于剩余预约次数')
                } else {
                    this.items[index].appointmentTimes++;
                    this.itemsFinalData[index].finalTimes = this.items[index].appointmentTimes;
                    this.itemsFinalData[index].finalPoints = Math.round(this.items[index].singlePoints * this.items[index].appointmentTimes);
                    this.itemsFinalData[index].finalCoupon = Math.round(this.items[index].singleCoupon * this.items[index].appointmentTimes);
                    this.itemsFinalData[index].finalGold = Math.round(this.items[index].singleGold * this.items[index].appointmentTimes);
                    this.itemsFinalData[index].finalPrice = Math.round(this.items[index].singlePrice * this.items[index].appointmentTimes);

                    Vue.set(this.items, index, this.items[index]);
                    Vue.set(this.itemsFinalData, index, this.itemsFinalData[index]);
                }
            },
            decreaseTimes(index) {
                if (this.items[index].appointmentTimes == 1) {
                    Toast('预约次数最小为1')
                } else {
                    this.items[index].appointmentTimes--;
                    this.itemsFinalData[index].finalTimes = this.items[index].appointmentTimes;
                    this.itemsFinalData[index].finalPoints = Math.round(this.items[index].singlePoints * this.items[index].appointmentTimes);
                    this.itemsFinalData[index].finalCoupon = Math.round(this.items[index].singleCoupon * this.items[index].appointmentTimes);
                    this.itemsFinalData[index].finalGold = Math.round(this.items[index].singleGold * this.items[index].appointmentTimes);
                    this.itemsFinalData[index].finalPrice = Math.round(this.items[index].singlePrice * this.items[index].appointmentTimes);
                    Vue.set(this.items, index, this.items[index]);
                    Vue.set(this.itemsFinalData, index, this.itemsFinalData[index]);
                }
            },
            deptChange() {
                this.items = this.itemsTemp.filter((currVal)=>{
                    return this.deptSelected == -1 || this.deptSelected == currVal.deptId;
                });
            },
            checkAnyItemChange(index, eve) {
                //console.log(eve);
                const treatment = this.items[index];
                if (eve.target.checked) {
                    this.selectedRecordId = treatment.consultRecordId;
                    const expertParams = {
                        deptId: treatment.deptId,
                        nationality: treatment.nationality,
                    };
                    userService.getExperts(expertParams).then((res) => {
                        if (res.statusCode == 200) {
                            if (res.data.length > 0) {
                                this.experts = res.data;
                                if (treatment.expertId) {
                                    this.expertSelected = treatment.expertId;
                                } else {
                                    this.expertSelected = this.experts[0].id;
                                }
                            }
                        }
                    });
                } else {
                    this.selectedRecordId = '';
                }
            },
            getExpertFreeTime() {
                if (this.appointmentDate == '' || this.expertSelected == '') {
                    return;
                }
                const params = {
                    expertId: this.expertSelected,
                    date: this.moment(this.appointmentDate, 'YYYY-MM-DD').valueOf()
                };
                schedulerService.getExpertFreeTime(params).then((res) => {
                    if (res.statusCode == 200) {
                        if (res.data.length > 0) {
                            res.data.forEach((item,i)=>{
                                Vue.set(this.expertFreeTimes, i, res.data[i]);
                            });
                        }
                    }
                })
            },
            applyAppointment() {
                if (this.expertFreeTimes.length == 0) {
                    if (this.appointmentDate !== '' && this.expertSelected !== '') {
                        const params = {
                            expertId: this.expertSelected,
                            date: this.moment(this.appointmentDate, 'YYYY-MM-DD').valueOf()
                        };
                        schedulerService.getExpertFreeTime(params).then((res) => {
                            if (res.statusCode == 200) {
                                if (res.data.length > 0) {
                                    res.data.forEach((item,i)=>{
                                        Vue.set(this.expertFreeTimes, i, res.data[i]);
                                    });
                                    this.postAdd();
                                }
                            }
                        })
                    }
                } else {
                    this.postAdd();
                }
            },
            postAdd() {
                if (this.selectedItems.length == 0) {
                    Toast('请选择需要预约的项目');
                    return;
                } else if (!this.appointmentDate) {
                    Toast('请先选择预约的日期');
                    return;
                } else if (!this.expertSelected) {
                    Toast('请选择预约的专家');
                    return;
                } else if (!this.appointmentTime) {
                    Toast('请选择预约时间');
                    return;
                }
                const beginTimeStr = this.appointmentDate + ' ' + this.appointmentTime;
                const monentBegin = this.moment(beginTimeStr, 'YYYY-MM-DD HH:mm:ss');
                const beginTime = monentBegin.valueOf(); //开始时间毫秒
                const monentEnd = monentBegin.add(this.operationTime, 'm');
                const endTime = monentEnd.valueOf(); //结束时间毫秒
                //console.log('毫秒', beginTime, '格式化：', this.moment(beginTime).format('YYYY-MM-DD HH:mm:ss'));
                //console.log('毫秒', endTime, '格式化：', this.moment(endTime).format('YYYY-MM-DD HH:mm:ss'));
                let isTimeOK = false;
                for (let i = 0; i < this.expertFreeTimes.length; i++) {
                    if (beginTime >= this.expertFreeTimes[i].beginTime && endTime <= this.expertFreeTimes[i].endTime) {
                        isTimeOK = true;
                    }
                }
                if (!isTimeOK){
                    Toast('预约时间超出了专家可约时间');
                    return;
                }
                const params = [];
                const filter = [];
                this.selectedItems.forEach((item, i) => {
                    filter.push(this.itemsFinalData[item.itemIndex]);
                });
                //console.log(filter);
                for (let i in filter) {
                    const param = {
                        beginTime: beginTime,
                        endTime: endTime,
                        consultRecordId: filter[i].consultRecordId,
                        treatmentId: filter[i].treatmentId,
                        treatmentCoupon: filter[i].finalCoupon,
                        treatmentGold: filter[i].finalGold,
                        treatmentPoint: filter[i].finalPoints,
                        treatmentPrice: filter[i].finalPrice,
                        treatmentTime: filter[i].finalTimes,
                        expertId: this.expertSelected,
                        memo: this.schedulerMemo
                    };
                    params.push(param);
                }
                console.log(params);
                schedulerService.addSchedulers(params).then((res)=>{
                    if (res.statusCode == 200) {
                        Toast('您已成功预约');
                        this.$router.push({path:'/scheduler/all'});
                    } else {
                        Toast(res.message);
                    }
                }).catch((err)=>{
                    console.log(err);
                })
            }
        },
        watch: {
            'expertSelected': function () {
                this.getExpertFreeTime();
            }
        },
        created() {
            const params = {
                customerId: this.$store.getters.customerId
            };
            schedulerService.getSupportAppointment(params).then((res) => {
                if (res.statusCode == 200) {
                    if (res.data.length > 0) {
                        this.items = res.data;
                        this.itemsTemp = res.data;
                        for (let i in res.data) {
                            this.items[i].appointmentTimes = 1;
                            this.itemsFinalData[i] = {
                                'treatmentId': this.items[i].treatmentId,
                                'consultRecordId': this.items[i].consultRecordId,
                                'finalTimes': this.items[i].times,
                                'finalPoints': this.items[i].singlePoints,
                                'finalCoupon': this.items[i].singleCoupon,
                                'finalGold': this.items[i].singleCoupon,
                                'finalPrice': this.items[i].singlePrice
                            };
                        }
                    } else {
                        this.emptyItem = true
                    }
                } else {
                    Toast(res.message)
                }
            });
            /*userService.getExperts().then((res) => {
              if (res.statusCode == 200) {
                if (res.data.length > 0) {
                  this.experts = res.data
                }
              }
            });*/

        }
    }
</script>

<style scoped>
  .block-n_04 .img001 {
    display: block;
    width: 30%;
    margin: 0 auto;
  }

  .block-n_04 .k-g {
    width: 100%;
    height: 50px;
    color: #84817f;
    font-size: 18px;
    text-align: center;
    margin-top: 15px;
  }

  #block-n_04 {
    margin: 0 auto 30px;
    padding: 51% 0;
    border-radius: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/scheduler/Appointment.vue